var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-area-page" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [_c("Navigation", { attrs: { page: "security" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "8" } },
                [
                  _c("h1", [_vm._v("Daten & Sicherheit")]),
                  _vm._v(" "),
                  _c("Info", {
                    attrs: {
                      meta: _vm.meta,
                      "get-security": _vm.getSecurity,
                      "change-identification": _vm.changeIdentification,
                      "resend-resend-function": _vm.resendResendFunction,
                      "resend-change-function": _vm.resendChangeFunction,
                      "with-identification": "",
                      "with-search-permission": ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }